import React from "react";

/**
 * CommentSkeleton component displays a loading skeleton for a comment
 * Used while comments are being fetched
 */
const CommentSkeleton = () => {
    return (
        <div className="tw-py-4 tw-border-b tw-border-gray-200 tw-animate-pulse">
            <div className="tw-flex tw-items-start tw-gap-3">
                <div className="tw-w-10 tw-h-10 tw-rounded-full tw-bg-gray-200" />
                <div className="tw-flex-1">
                    <div className="tw-flex tw-items-baseline tw-justify-between">
                        <div className="tw-h-4 tw-w-24 tw-bg-gray-200 tw-rounded" />
                        <div className="tw-h-4 tw-w-20 tw-bg-gray-200 tw-rounded" />
                    </div>
                    <div className="tw-h-4 tw-w-full tw-bg-gray-200 tw-rounded tw-mt-2" />
                    <div className="tw-h-4 tw-w-16 tw-bg-gray-200 tw-rounded tw-mt-2" />
                </div>
            </div>
        </div>
    );
};

export default CommentSkeleton;
